const getProductFromSlug = (products, slug) => {
  for (let i = 0; i < products.length; i++) {
    if (products[i].metadata.store_slug === slug) return products[i]
  }
  return null
}

export default getProductFromSlug
